'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCommonInterface;

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _Snapshot = require('../Snapshot');

var _Snapshot2 = _interopRequireDefault(_Snapshot);

var _Suite = require('../Suite');

var _Suite2 = _interopRequireDefault(_Suite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('react-percy:test-framework');

function getCommonInterface(suites) {
  var snapshotNames = {};

  return {
    beforeAll: function beforeAll(fn) {
      suites[0].addBeforeAll(fn);
    },
    beforeEach: function beforeEach(fn) {
      suites[0].addBeforeEach(fn);
    },
    afterEach: function afterEach(fn) {
      suites[0].addAfterEach(fn);
    },
    afterAll: function afterAll(fn) {
      suites[0].addAfterAll(fn);
    },
    suite: function suite(title, options, fn) {
      if (typeof fn === 'undefined') {
        fn = options;
        options = undefined;
      }
      var suite = new _Suite2.default(title, options);
      suites[0].addSuite(suite);
      suites.unshift(suite);
      if (suite.fullTitle()) {
        debug('processing suite %o', suite.fullTitle());
      }
      if (typeof fn === 'function') {
        fn.call(suite);
      }
      if (suite.fullTitle()) {
        debug('finished processing suite %o', suite.fullTitle());
      }
      suites.shift();
      return suite;
    },
    snapshot: function snapshot(title, options, fn) {
      var snapshot = new _Snapshot2.default(title, options, fn);
      suites[0].addSnapshot(snapshot);
      var snapshotFullTitle = snapshot.fullTitle();
      if (snapshotNames[snapshotFullTitle]) {
        throw new Error('A snapshot named `' + snapshotFullTitle + '` has already been added, please use a different name');
      }
      snapshotNames[snapshotFullTitle] = true;
      debug('added snapshot %o', snapshotFullTitle);
      return snapshot;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-test-framework/lib/interfaces/getCommonInterface.js
// module id = 478
// module chunks = 1